var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummerBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 662.457,
    height: 428.954,
    viewBox: "0 0 175.275 113.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 212.747,
    x2: -73.381,
    y1: 296.28,
    y2: -96.104,
    gradientTransform: "matrix(.81183 0 0 .2031 7.527 336.883)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d6fdff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7cf9ff",
      stopOpacity: 0.36078432
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204313,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204313,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 365.176v32.029h175.276v-32.029Z",
    style: {
      fill: "#ffe680",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.05693531,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 340.955v27.575q.611.08 1.206.203c1.781.37 3.022 1.146 5.024 1.657 5.596 1.431 14.136 2.629 23.585.94 12.549-1.998 20.182-3.085 28.825-4.366 6.787-1.1 13.904-.411 20.714.617s13.568 2.398 20.527 2.66c13.695.517 26.944-3.269 40.597-4.17 12.092-.8 24.828.854 34.798 5.58v-30.696z",
    style: {
      fill: "#8de8ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".1788792px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-7.527 -283.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.643 262.743a8.4 8.4 0 0 0 .296 4.24 8.4 8.4 0 0 0 2.345 3.544c1.918 1.713 4.656 2.462 7.18 1.964",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.643 262.743a8.4 8.4 0 0 0 .296 4.24 8.4 8.4 0 0 0 2.345 3.544c1.918 1.713 4.656 2.462 7.18 1.964",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.14921 .10454 .10454 .14921 66.81 5.873)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.18219)rotate(-35.014 821.873 1280.281)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.18219)rotate(-35.014 825.725 1276.415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.14921 .10454 .10454 .14921 66.801 5.879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.14921 .10454 .10454 .14921 66.922 6.471)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.14921 .10454 .10454 .14921 67 7.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.621 273.801a12.35 12.35 0 0 1-12.348 12.348 12.35 12.35 0 0 1-12.348-12.348 12.35 12.35 0 0 1 12.348-12.348 12.35 12.35 0 0 1 12.348 12.348",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.88600004,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.506 252.858 2.39 10.12a5.204 5.204 0 0 1-6.134-3.895 5.204 5.204 0 0 1 3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.126 252.858-2.39 10.12a5.204 5.204 0 0 0 6.134-3.895 5.204 5.204 0 0 0-3.744-6.225M602.58 252.858l2.389 10.12a5.204 5.204 0 0 1-6.134-3.895 5.204 5.204 0 0 1 3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607.2 252.858-2.39 10.12a5.204 5.204 0 0 0 6.133-3.895 5.204 5.204 0 0 0-3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.402 261.64a3.18 3.18 0 0 1-3.18 3.18 3.18 3.18 0 0 1-3.18-3.18 3.18 3.18 0 0 1 3.18-3.18 3.18 3.18 0 0 1 3.18 3.18",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.675 261.64a2.453 2.453 0 0 1-2.453 2.453 2.453 2.453 0 0 1-2.453-2.453 2.453 2.453 0 0 1 2.453-2.453 2.453 2.453 0 0 1 2.453 2.453",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.36122119,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.583 261.64a1.36 1.36 0 0 1-1.361 1.362 1.36 1.36 0 0 1-1.362-1.362 1.36 1.36 0 0 1 1.362-1.361 1.36 1.36 0 0 1 1.361 1.361",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.75555301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.416 261.64a3.18 3.18 0 0 1-3.18 3.18 3.18 3.18 0 0 1-3.181-3.18 3.18 3.18 0 0 1 3.18-3.18 3.18 3.18 0 0 1 3.18 3.18",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.688 261.64a2.453 2.453 0 0 1-2.453 2.453 2.453 2.453 0 0 1-2.453-2.453 2.453 2.453 0 0 1 2.453-2.453 2.453 2.453 0 0 1 2.453 2.453",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.36122119,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.597 261.64a1.36 1.36 0 0 1-1.362 1.362 1.36 1.36 0 0 1-1.361-1.362 1.36 1.36 0 0 1 1.361-1.361 1.36 1.36 0 0 1 1.362 1.361",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.75555301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.18219)rotate(-35.014 817.711 1283.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.79 196.63.471.47h2.02l.404-.473z",
    style: {
      fill: "#ffbb96",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(3.04095 0 0 3.04095 -1109.907 -542.131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.125 196.625v-1.541h.077v1.548z",
    style: {
      fill: "#cf8256",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".46847188px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(3.04095 0 0 3.04095 -1109.907 -542.131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m418.202 195.084 1.2 1.2h-1.197z",
    style: {
      fill: "#ffbb96",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".46847188px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(3.04095 0 0 3.04095 -1109.907 -542.131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.643 262.743a8.4 8.4 0 0 0 .296 4.24 8.4 8.4 0 0 0 2.345 3.544c1.918 1.713 4.656 2.462 7.18 1.964",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.643 262.743a8.4 8.4 0 0 0 .296 4.24 8.4 8.4 0 0 0 2.345 3.544c1.918 1.713 4.656 2.462 7.18 1.964",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.24618 .24618)rotate(-24.715 318.607 3067.633)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.24618)rotate(24.715 257.044 406.874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.24618)rotate(24.715 249.64 408.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.24618 .24618)rotate(-24.715 318.58 3067.512)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.24618 .24618)rotate(-24.715 324.863 3062.971)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17 275.172a5.3 5.3 0 0 0-2.58.132c-.91.28-1.74.809-2.377 1.515a5.3 5.3 0 0 0-1.261 2.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.24618 .24618)rotate(-24.715 330.745 3058.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.621 273.801a12.35 12.35 0 0 1-12.348 12.348 12.35 12.35 0 0 1-12.348-12.348 12.35 12.35 0 0 1 12.348-12.348 12.35 12.35 0 0 1 12.348 12.348",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.88600004,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.506 252.858 2.39 10.12a5.204 5.204 0 0 1-6.134-3.895 5.204 5.204 0 0 1 3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m564.126 252.858-2.39 10.12a5.204 5.204 0 0 0 6.134-3.895 5.204 5.204 0 0 0-3.744-6.225M602.58 252.858l2.389 10.12a5.204 5.204 0 0 1-6.134-3.895 5.204 5.204 0 0 1 3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607.2 252.858-2.39 10.12a5.204 5.204 0 0 0 6.133-3.895 5.204 5.204 0 0 0-3.744-6.225",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.79486996,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.402 261.64a3.18 3.18 0 0 1-3.18 3.18 3.18 3.18 0 0 1-3.18-3.18 3.18 3.18 0 0 1 3.18-3.18 3.18 3.18 0 0 1 3.18 3.18",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.675 261.64a2.453 2.453 0 0 1-2.453 2.453 2.453 2.453 0 0 1-2.453-2.453 2.453 2.453 0 0 1 2.453-2.453 2.453 2.453 0 0 1 2.453 2.453",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.36122119,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.583 261.64a1.36 1.36 0 0 1-1.361 1.362 1.36 1.36 0 0 1-1.362-1.362 1.36 1.36 0 0 1 1.362-1.361 1.36 1.36 0 0 1 1.361 1.361",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.75555301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.416 261.64a3.18 3.18 0 0 1-3.18 3.18 3.18 3.18 0 0 1-3.181-3.18 3.18 3.18 0 0 1 3.18-3.18 3.18 3.18 0 0 1 3.18 3.18",
    style: {
      fill: "#ff4b00",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.76499999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.688 261.64a2.453 2.453 0 0 1-2.453 2.453 2.453 2.453 0 0 1-2.453-2.453 2.453 2.453 0 0 1 2.453-2.453 2.453 2.453 0 0 1 2.453 2.453",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.36122119,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.597 261.64a1.36 1.36 0 0 1-1.362 1.362 1.36 1.36 0 0 1-1.361-1.362 1.36 1.36 0 0 1 1.361-1.361 1.36 1.36 0 0 1 1.362 1.361",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.75555301,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.36078431,
      paintOrder: "normal"
    },
    transform: "scale(.24618)rotate(24.715 264.65 405.376)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummerBreak);
export default __webpack_public_path__ + "static/media/summer-break.2c2e5c54cbacf6c31bdb72f42f8600b3.svg";
export { ForwardRef as ReactComponent };